import React, { Component } from 'react'
import StagesManager from '../../../components/StagesManager';
import NewInqueryInfo from './NewInqueryInfo';
import FormBuilderNew from '../../../components/FormBuilderNew';
import InquirySuccess from './InquirySuccess';
import Header from '../../../components/header/Header';
import { setObject } from '../../../utils/useful';
import HttpServices from '../../../utils/Http.services';
import ret from 'mammoth/mammoth.browser';
import AnswerSheet from './AnswerSheet';
import UserAnswerSheet from './UserAnswerSheet';

class
    NewInquiry extends Component {

    state = {
        data: {},
        tempValue: {},
        headers: [
            { key: 'values.title', type: 'TextInput', information: { label: '{{lang}}Name', required: true, placeholder: '{{lang}}Name', } },
            { key: 'values.description', type: 'TextAreaInput', information: { label: '{{lang}}Description', required: true, placeholder: '{{lang}}Description', } },
            // { key: 'values.teacher', type: 'TextInput', information: { label: '{{lang}}Teacher', required: false, placeholder: '{{lang}}Teacher', } },
            { key: 'values.teacher', type: 'GlobalUserInput', information: { label: '{{lang}}Teacher', required: false, placeholder: '{{lang}}Teacher', type: 'api', address: 'searchUser', filter: {}, fields: { title: 'fullname', value: '_id', description: 'username', image: 'image' } } },
            { key: 'values.date', type: 'DateTimeInput', information: { label: '{{lang}}Start Date', required: true, placeholder: '{{lang}}Start Date', } },
            { key: 'values.expiryDate', type: 'DateTimeInput', showDisabledButton: true, information: { label: '{{lang}}Expiry Date', required: false, placeholder: '{{lang}}Expiry Date', disabled: true } },
            { key: 'values.duration', type: 'DurationInput', showDisabledButton: true, information: { label: '{{lang}}Duration', required: false, placeholder: '{{lang}}Duration', disabled: true, } },
            { key: 'values.retakeNumber', type: 'NumberInput', showDisabledButton: true, information: { label: '{{lang}}Retake Number', required: false, placeholder: '{{lang}}Retake Number', disabled: true, } },
        ],
        time: '',
        record: {},
        headerConfig: {
            backAction: () => this.hideModal(),
            // 'title': "View Record",
            // 'subtitle': this.props.page?.subtitle,

        },
        hasAnswerSheet: false,
        hasScore:false,
        canSeeAnswer:false,
        // scoreHeader:[]
    }

    hideModal = () => {
        // console.log('aaaaaaaaaaas')
        this.onClose()
        // setTimeout(() => {
        //     this.setState({ showModal: false })
        // }, 500);
    }
    onClose = () => {
        setTimeout(() => {
            if (this.props.setData) {
                // console.log('aaaaaaaaaaaaaa')
                this.props.setData('newInquiry', false, 'CollectionView', () => {
                    this.props.setData('editInquiry', false, 'CollectionView', () => {
                        this.setState({ showModal: false, })
                    })
                })
            } else {

                this.setState({ showModal: false, }, () => {
                    // this.setState({  })
                })
            }
        }, 10);
        if (this.props.onClose) {
            this.props.onClose()
        }
    }
    // this.props.setData('editInquiry', false, 'collectionView')
    componentDidMount() {
        this.init()
        // console.log('defaultCollectionHeader;;', this.props)
        // let data = this.state.data
        // if (this.props.data) {
        //     data = this.props.data
        // }
        // console.log(data)
        // this.setState({ data })
        let collectionId = this.props.windowData?.path[this.props.baseUrl?.length]
        if (this.props.collectionId) {
            collectionId = this.props.collectionId
        }
        // console.log('this.props.dataIs', this.props.initData)
        let headers = this.state.headers
        // headers = this.props.applet?.frames[0]?.frame?.fields
        this.setState({ collectionId, headers }, () => [
        ])
        // this.props.setHeader({
        //     'toolbar': null,
        //     'showToolbar': false,
        //     topHeaderComponent: this.topHeaderComponent,
        //     title: '{{lang}}New Inquery',
        //     // headerIdentityComponent: this.headerIdentityComponent,
        //     backAction: () => this.props.changePage('pages')
        // })
    }

    componentDidUpdate(prevProps) {

        if (this.props.data != prevProps.data) {
            this.init()
        }
        // console.log('duratioooon', this.state.data)

    }

    init = () => {
        // console.log(this.props.data)
        this.setState({ data: this.props.data })

    }

    changeValue = (value) => {
        let tempValue = value
        this.setState({ tempValue }, () => {
            // console.log('temp cval', this.state.tempValue)
        })
    }






    postRecord = (cb) => {
        // let rawData = this.state.formContent
        // let data = {}
        let data = { ...this.state.data }
        // if (data.time) {
        //     data.duration = `${data.time[0]}:${data.time[1]}:${data.time[2]}`
        // }
        // if (rawData) {
        //     let questions = []

        //     rawData[0].pageContent[0].sectionContent.map((prop) => {
        //         prop.rowContent.map((element) => {
        //             questions.push(element)
        //         })
        //     })
        //     // console.log('questionnnnnn', questions)
        //     // return

        //     // data.values = { ...data }

        //     data.values.questions = questions


        data.applet = this.props.applet._id
        data.frame = this.state.collectionId

        data.hub = this.props.applet.hub._id ?? this.props.applet.hub
        // console.log('dataaaaaaaaaa===', data)
        // return
        this.setState({ isLoadingPost: true })
        
        // return
        // console.log('datassss', data)
        HttpServices.request('postRecord', data, (fetchResult, fetchError) => {
            // console.log('pooooooooooooooost', fetchResult)
            this.setState({ isLoadingPost: false })

            if (fetchError) {
                return
            }

            if (fetchResult) {
                this.props.setData('record', fetchResult.info)
            }

            cb()

this.setState({record:fetchResult.info},()=>{

    this.stageManager.changeStage('success')
})
        })
        // this.showSubmitModal()
        // }
    }

    postEditRecord = (cb) => {
        // let rawData = this.state.formContent
        // let data = {}
        let path = this.props.windowData.path
        let data = { ...this.state.data }
        // if (rawData) {
        //     let questions = []
        //     rawData[0].pageContent[0].sectionContent.map((prop) => {
        //         prop.rowContent.map((element) => {
        //             questions.push(element)
        //         })
        //     })
        // console.log('questionnnnnn', questions)
        // return
        // data.questions = questions

        // data.values = { ...data }

        data.applet = this.props.applet._id
        data.frame = this.state.collectionId

        data.hub = this.props.applet.hub._id ?? this.props.applet.hub
        data._id = path[path.length - 1]
        // console.log('dataaaaaaaaaa===', data)
        // return
        this.setState({ isLoadingPost: true })
        HttpServices.request('updateRecord', data, (fetchResult, fetchError) => {
            // console.log('fetchError', fetchError)
            // console.log('fetchResult', fetchResult)

            if (fetchError) {
                return
            }

            this.setState({ isLoadingPost: false })
            if (fetchResult) {
                this.props.setData('record', fetchResult.info)
            }
            cb()

            this.setState({record:fetchResult.info},()=>{

                this.stageManager.changeStage('success')
            })
        })
        // this.showSubmitModal()
        // }
    }

    // componentDidUpdate(prevProps) {}

    // groupBy = (keyIndex = 0, data = this.state.data, keys) => {
    //     if (keys && keys.length > 0) {
    //         if (keyIndex == 0) {
    //             this.setState({ orgData: this.state.data })
    //         }
    //         let group = {}
    //         let headers = this.state.headers
    //         if (data) {
    //             let key = keys[keyIndex]
    //             let header
    //             headers.forEach(element => {
    //                 if (key == element.key) {
    //                     header = element
    //                 }
    //             });
    //             if (Array.isArray(data)) {
    //                 data.forEach(element => {
    //                     let value = getObject(element, key)
    //                     if (Array.isArray(value)) {
    //                         value = value[value.length - 1]
    //                     }
    //                     value = String(value)
    //                     if (!group[value]) {
    //                         group[value] = { data: [], header, id: nanoid() }
    //                     }
    //                     group[value].data.push(element)
    //                 });
    //             } else {}
    //             if (keyIndex != keys.length - 1) {
    //                 for (const [groupKey, groupValues] of Object.entries(group)) {
    //                     group[groupKey] = { header, id: nanoid(), data: this.groupBy(keyIndex + 1, groupValues.data, keys) }
    //                 }
    //             }
    //             console.log(group)
    //             if (keyIndex == 0) {
    //                 this.setState({ data: group })
    //             }
    //             return group
    //         }
    //     }
    // }

    // init() {
    //     if (this.state.page) {
    //         let appletHub = typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub?._id : this.props.applet?.hub
    //         let variables = {
    //             appletId: this.props.applet?._id,
    //             appletHub: appletHub
    //         }
    //         this.setState({ data: {}, variables }, () => {
    //             this.fetchData()
    //         })
    //     }
    // }

    // getFrames() {
    //     let data = {}
    //     data.applet = this.props.applet._id
    //     let list = this.state.list
    //     HttpServices.request('getFrames', data, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             return
    //         }
    //         list = fetchResult.info
    //         this.setState({ list, currentFrameName: fetchResult.info[0].name })
    //     })
    // }

    // fetchData = () => {
    //     this.setState({ isLoadingData: true })
    //     let body = this.state.page.filter ?? {}
    //     let page = this.state.page
    //     for (const [key, value] of Object.entries(body)) {
    //         if (/\{\{(.*?)\}\}/.test(value)) {
    //             if (this.state.variables) {
    //                 body[key] = this.state.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //             }
    //         }
    //     }
    //     body.frame = this.state.currentFrame?._id
    //     HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingData: false })
    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
    //             return
    //         }
    //         this.setState({ showTable: false }, () => {
    //             this.setState({ records: fetchResult.info, showTable: true }, () => {
    //                 this.groupBy(0, this.state.records, this.state.groupBy)
    //             })
    //         })
    //     })
    // }

    backStage = () => {
        this.stageManager.lastStage((stage) => {
            let showToolbar = false
            let shouldHaveToolbar = ['start', 0]
            if (shouldHaveToolbar.includes(stage)) {
                showToolbar = true
            }
            let showBackBtn = true
            let shouldHaveBackBtn = ['start', 0]
            if (shouldHaveBackBtn.includes(stage)) {
                showBackBtn = false
            }
            this.setState({ showToolbar, showBackBtn })
        })
    }

    changePageStage = (stage) => {
        // let showToolbar = false
        // let shouldHaveToolbar = ['start',]
        // if (shouldHaveToolbar.includes(stage)) {
        //     showToolbar = true
        // }
        // let showBackBtn = true
        // let shouldHaveBackBtn = ['start',]
        // if (shouldHaveBackBtn.includes(stage)) {
        //     showBackBtn = false
        //     this.setState({ data: {} })
        // }
        this.stageManager.changeStage(stage)
        // this.setState({ showToolbar, showBackBtn })
    }

    // changeBackbtn = (check) => {
    //     this.setState({ backbtn: check }, () => {
    //         // console.log('987654321', this.state.backbtn)
    //     })
    // }

    // setData = (key, value, cb) => {
    //     this.setState({ [key]: value }, () => {
    //         if (cb) {
    //             cb()
    //         }
    //     })
    // }


    setData = (data, cb) => {
        let newDate = this.state.data
        if (!newDate) {
            newDate = {}
        }
        if (data == null) {
            newDate = null
        } else {
            for (const [key, value] of Object.entries(data)) {
                // newDate[key] = value
                setObject(newDate, key, value)
            }
        }
        this.setState({ data: newDate }, () => {
            if (cb) { cb() }
        })

    }

    onChangeAnswerSheet = () => {
        let hasAnswerSheet = this.state.hasAnswerSheet
        hasAnswerSheet = !hasAnswerSheet
        this.setState({ hasAnswerSheet })
    }

    onChangeScore = () => {
        let hasScore = this.state.hasScore
        hasScore = !hasScore
        this.setState({ hasScore })
    }

    lastStagePage = () => {
        this.props.removeWindowLink()
        this.stageManager.lastStage()
    }

    goToHub = () => {
        let username = this.state.applet?.hub?.username
        this.props.changeWindow('hub', { path: [username] })
    }

    addNewForm = () => {
        this.props.changeWindowLink(['settings', 'newForm'])
        this.changePage('settings')
    }

    visitQuiz = () => {
        // let path = this.props.windowData.path
        // let appId = this.state.data?.slug ?? this.state.data?.urlcode
        // this.props.changeWindow('applet', { path: [this.state.hubInfo?.username, appId] })
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: false,
                    backAction: () => this.hideModal(),
                    // 'title': "View Record",
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    render() {
        // console.log('xaasxcascsacsac',this.props.variables);
        if (this.props.newInquiry || this.props.editInquiry) {
            return (
                <div className='h-100 flex-column window-content-radius-bottom' style={{ display: (this.props.editInquiry || this.props.newInquiry) ? 'flex' : 'none', width: '100%', left: 50, zIndex: 3, backgroundColor: 'rgb(229, 229, 234)' , overflow:'hidden'}}>
                    {/* <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                    </div> */}
                    {/* <div style={{ position: 'sticky', top: 0, zIndex: 9 }}>
                    <Header type={'inquery'} language={this.props.language} types={'normal'} toolbarView={'applet'} headertype={'applet'} changeWindow={this.changePage} currentFrame={this.state.currentFrame} list={this.state.list} goToHub={this.props.goToHub} backStage={this.backStage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} color={this.state.bg} color2={this.state.bg2} toolbar={this.state.showToolbar} addNewForm={this.addNewForm} />
                </div> */}
                    <div className='' style={{ height: '100%', backgroundColor: '#fff' }}>
                        {/* {console.log('this.props.defaultCollectionHeaderCheck',this.props.defaultCollectionHeader)} */}
                        <StagesManager ref={el => this.stageManager = el} fast={true} height={'100%'}  >
                            {/* <SelectQuery stage={0} stageName={'select'} language={this.props.language} backStage={this.backStage} setData={this.setData} changeStage={this.changePage} width={this.props.width} data={this.state.data} /> */}
                            <NewInqueryInfo  participation={this.props.participation} stage={0} stageName={'info'} variables={this.props.variables} language={this.props.language} colors={this.props.colors} newInquiry={this.props.newInquiry} editInquiry={this.props.editInquiry} setHeader={this.props.setHeader} backStage={this.backStage} setData={this.setData} setData2={this.props.setData} headers={this.props.headers} initData={this.state.data} changeStage={this.changePageStage} changePage={this.props.changePage} collectionId={this.state.collectionId} data={this.state.data} width={this.props.width} editForm={this.props.editForm} defaultCollectionHeader={this.props.defaultCollectionHeader} />
                            <FormBuilderNew stage={1} stageName={'form'} language={this.props.language} colors={this.props.colors} newInquiry={this.props.newInquiry} editInquiry={this.props.editInquiry} setHeader={this.props.setHeader} collectionId={this.state.collectionId} setData2={this.props.setData} headers={this.state.headers} currentFrame={this.state.currentFrame} backStage={this.backStage} type='quiz' setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePageStage} changePage={this.props.changePage} applet={this.props.applet} goToHub={this.props.goToHub} windowData={this.props.windowData} initData={this.state.data?.values?.questions} route={this.props.rootUrl} connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} addNotif={this.props.addNotif} history={this.props.history} location={this.props.location} editForm={this.props.editForm} defaultCollectionHeader={this.props.defaultCollectionHeader} postEditRecord={this.postEditRecord} postRecord={this.postRecord} />
                            <AnswerSheet  participation={this.props.participation} stage={1} stageName={'answerSheet'} language={this.props.language} colors={this.props.colors} newInquiry={this.props.newInquiry} editInquiry={this.props.editInquiry} setHeader={this.props.setHeader} collectionId={this.state.collectionId} setData2={this.props.setData} headers={this.state.headers} currentFrame={this.state.currentFrame} backStage={this.backStage} type='quiz' setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePageStage} changePage={this.props.changePage} applet={this.props.applet} goToHub={this.props.goToHub} windowData={this.props.windowData} initData={this.state.data?.values?.questions} route={this.props.rootUrl} connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} addNotif={this.props.addNotif} history={this.props.history} location={this.props.location} editForm={this.props.editForm} defaultCollectionHeader={this.props.defaultCollectionHeader} postEditRecord={this.postEditRecord} postRecord={this.postRecord} hasAnswerSheet={this.state.hasAnswerSheet} onChangeAnswerSheet={this.onChangeAnswerSheet} hasScore={this.state.hasScore} canSeeAnswer={this.state.canSeeAnswer} onChangeScore={this.onChangeScore} scoreHeader={this.state.scoreHeader} />
                            <UserAnswerSheet  participation={this.props.participation} stage={1} stageName={'userAnswerSheet'} language={this.props.language} colors={this.props.colors} newInquiry={this.props.newInquiry} editInquiry={this.props.editInquiry} setHeader={this.props.setHeader} collectionId={this.state.collectionId} setData2={this.props.setData} headers={this.state.headers} currentFrame={this.state.currentFrame} backStage={this.backStage} type='quiz' setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePageStage} changePage={this.props.changePage} applet={this.props.applet} goToHub={this.props.goToHub} windowData={this.props.windowData} initData={this.state.data?.values?.questions} route={this.props.rootUrl} connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} addNotif={this.props.addNotif} history={this.props.history} location={this.props.location} editForm={this.props.editForm} defaultCollectionHeader={this.props.defaultCollectionHeader} postEditRecord={this.postEditRecord} postRecord={this.postRecord} hasAnswerSheet={this.state.hasAnswerSheet} onChangeAnswerSheet={this.onChangeAnswerSheet} hasScore={this.state.hasScore} canSeeAnswer={this.state.canSeeAnswer} onChangeScore={this.onChangeScore} scoreHeader={this.state.scoreHeader} />
                            {/* <SelectNameSurvey stage={1} stageName={'survey'} language={this.props.language} colors={this.props.colors}newInquiry={this.props.newInquiry} editInquiry={this.props.editInquiry}setHeader={this.props.setHeader} backStage={this.backStage} setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePageStage}  changePage={this.props.changePage}/> */}
                            <InquirySuccess stage={1} stageName={'success'} language={this.props.language} colors={this.props.colors} newInquiry={this.props.newInquiry} editInquiry={this.props.editInquiry} setHeader={this.props.setHeader} backStage={this.backStage} setData={this.setData} setData2={this.props.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePageStage} changePage={this.props.changePage} visitQuiz={this.visitQuiz} windowData={this.props.windowData} editForm={this.props.editForm} record={this.state.record} changeWindowLink={this.props.changeWindowLink} changeReportPage={this.props.changeReportPage} baseUrl={[...this.props.baseUrl]} />
                            {/* <Recents stage={0} stageName={'start'} language={this.props.language} changeBackbtn={this.changeBackbtn} changePage={this.changePage} changeValue={this.changeValue} tempValue={this.state.tempValue} headers={this.state.headers} goToHub={this.props.goToHub} setData={this.setData} changeStage={this.changePageStage} width={this.props.width} data={this.state.records} height={this.props.height} windowData={this.props.data} route={this.props.rootUrl} applet={this.props.applet} connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} addNotif={this.props.addNotif} history={this.props.history} location={this.props.location} /> */}
                            {/* <Reports stage={0} stageName={'Reports'} language={this.props.language} changeBackbtn={this.changeBackbtn} backStage={this.backStage} setData={this.setData} changeStage={this.changePage} width={this.props.width} data={this.state.data} /> */}
                            {/* <SelectLevel stage={0} stageName={'second'} setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePage} /> */}
                            {/* <FormBuilderNew stage={1} stageName={'surveyForm'} variables={this.props.variables} language={this.props.language} currentFrame={this.state.currentFrame}  type='survey' setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePage} applet={this.props.applet} goToHub={this.props.goToHub} windowData={this.props.data} route={this.props.rootUrl} connection={this.props.connection} user={this.props.user} setUser={this.props.setUser} addNotif={this.props.addNotif} history={this.props.history} location={this.props.location} /> */}
                            {/* <FormBuilderNew variables={this.props.variables} stage={1} stageName={'fourth'} setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePage} /> */}
                            {/* <SelectNameExam stage={0} stageName={'exams'} language={this.props.language} backStage={this.backStage} setData={this.setData} width={this.props.width} height={this.props.height} data={this.state.data} pages={this.state.pages} changeStage={this.changePage} /> */}
                            {/* <DatabaseSettings stage={0} stageName={'settings'}  automations={this.state.automations} language={this.props.language} currentFrame={this.state.currentFrame} userSettings={this.state.userSettings} removeWindowLink={this.props.removeWindowLink} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} windowData={this.props.windowData} width={this.props.width} route={this.props.route} changeStage={this.changePage} applet={this.props.applet} goToHub={this.props.goToHub} variables={this.props.variables} /> */}
                        </StagesManager>
                    </div>
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }
}

export default NewInquiry;